import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { openPopup } from "../../store/popupSlice"

export default function Landing2Choose() {
  const dispatch = useDispatch();
  return (
    <>
      <section className="land2-choose-area">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="land2-choose-head">
                <h3 className="heading center-heading">Why Choose <span className="gradiant-color"> Mobility Infotech?</span></h3>
                <div className="row justify-content-center">
                  <div className="col-lg-7 text-center">
                    <label>Because we care about your taxi business.</label>
                    <p>We prioritize your success by offering more than just software. Our deep mobility expertise ensures customized taxi solutions that drive growth.</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="land2-choose-box">
                <span><img loading="lazy" src="/assets/home/land2-choose-icon-1.webp" alt="icon" className="img-responsive" /></span>
                <h4>Scalability</h4>
                <p>Effortlessly expand your business with our scalable dispatch solution.</p>
              </div>
            </div>

            <div className="col-lg-4 col-md-6">
              <div className="land2-choose-box">
                <span><img loading="lazy" src="/assets/home/land2-choose-icon-2.webp" alt="icon" className="img-responsive" /></span>
                <h4>24/7 Support</h4>
                <p>Receive expert assistance anytime, ensuring smooth operations.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="land2-choose-box">
                <span><img loading="lazy" src="/assets/home/land2-choose-icon-3.webp" alt="icon" className="img-responsive" /></span>
                <h4>Secure Platform</h4>
                <p>Protect your data with top-tier security standards.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="land2-choose-box">
                <span><img loading="lazy" src="/assets/home/land2-choose-icon-4.webp" alt="icon" className="img-responsive" /></span>
                <h4>Best Price</h4>
                <p>Enjoy pay-as-you-go pricing without long-term contracts.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="land2-choose-box">
                <span><img loading="lazy" src="/assets/home/land2-choose-icon-5.webp" alt="icon" className="img-responsive" /></span>
                <h4>High Configurability</h4>
                <p>Tailor every feature to fit your business requirements.</p>
              </div>
            </div>
            <div className="col-lg-4 col-md-6">
              <div className="land2-choose-box">
                <span><img loading="lazy" src="/assets/home/land2-choose-icon-6.webp" alt="icon" className="img-responsive" /></span>
                <h4>Easy Integration</h4>
                <p>Connect seamlessly with third-party tools and platforms.</p>
              </div>
            </div>

            <div className="col-lg-12">
              <div className="land2-rider-butn land2-choose-btns">
                <h4>Mobility Infotech - A Smarter Way to Manage Your Transport Business</h4>
                <button onClick={() => dispatch(openPopup())} className="default-btn">Schedule a free Demo</button>
                <Link to={"/features/taxi-software"}><button className="default-white">Explore More</button></Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
